"use client"

import { cn } from "@/lib/utils"

import { useState } from "react"
import { AdvisorRailCard } from "@/components/rail/advisor-rail-card"
import { EphemeralConfirmation } from "@/components/rail/ephemeral-confirmation"
import { buildRailItemsFromSession } from "@/lib/rail/rail-adapter"
import type { RailAction } from "@/lib/rail/rail.types"

interface StrategicFeedProps {
  userId: string
  tenantId: string
  conversationId?: string
}

interface Confirmation {
  id: string
  message: string
  detail?: string
}

export function StrategicFeed({ userId, tenantId, conversationId }: StrategicFeedProps) {
  const railItems = buildRailItemsFromSession({ userId, tenantId, conversationId })
  const [activeConfirmation, setActiveConfirmation] = useState<Confirmation | null>(null)

  const handleCardAction = (action: RailAction) => {
    console.log("[v0] StrategicFeed: Card action triggered:", action.intent, action.id)

    if (action.intent === "approve") {
      setActiveConfirmation({
        id: `confirm-${Date.now()}`,
        message: "Saved to Business Brain",
        detail: action.label || "Memory approved",
      })
    }

    // TODO: Wire up real actions:
    // - approve: save to memories table
    // - edit: open edit modal
    // - dismiss: mark as dismissed
    // - inject_prompt: populate chat input
    // - navigate: router.push(action.href)
    // - discuss: open discussion thread
    // - resolve: mark decision as resolved
  }

  // Filter out confirmation cards from rail items (they're now ephemeral only)
  const displayItems = railItems.filter((item) => item.type !== "confirmation")

  return (
    <div className="flex flex-col h-full overflow-y-auto">
      <div className="flex-1 p-4 space-y-4">
        {activeConfirmation && (
          <EphemeralConfirmation
            message={activeConfirmation.message}
            detail={activeConfirmation.detail}
            onDismiss={() => setActiveConfirmation(null)}
          />
        )}

        {displayItems.map((item, index) => {
          const isGoalAnchor = item.type === "goal_anchor"
          const prevItem = index > 0 ? displayItems[index - 1] : null
          const needsExtraSpacing = prevItem?.type === "goal_anchor"

          return (
            <div key={item.id} className={cn(needsExtraSpacing && "mt-2")}>
              <AdvisorRailCard item={item} onAction={handleCardAction} isGoalAnchor={isGoalAnchor} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
